import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-outgoing-box-icon',
  templateUrl: './communication-outgoing-box.component.html'
})
export class CommunicationOutgoingBoxComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
